export default {
  wrapper: {
    navBar: {
      menu: {
        account: {
          profile: "Profile",
          FAQ: "FAQ",
          logout: "Logout"
        }
      }
    }
  },
  application: {
    list: {
      active: {
        title: "Active application list"
      },
      archived: {
        title: "Archived application list"
      },
      column: {
        id: "ID",
        createdAt: "created at",
        name: "name",
        domain: "domain",
        accountManagerNote: "account manager",
        note: "company",
        status: "status",
        actions: ""
      },
      status: {
        failed: "Failed",
        successful: "Online",
        "in-progress": "Loading",
        pending: "Pending",
        offline: "Offline",
        archived: "Archived",
        erased: "Erased"
      },
      transitionState: {
        new: "error while creating..",
        archived: "error while archiving..",
        deployed: "error while deploying.."
      },
      actions: {
        delete: {
          tooltip: "Delete selected applications",
          confirmation: "Delete selected applications?"
        },
        createViaDrawer: {
          tooltip: "Create application - drawer"
        }
      },
      localization: {
        body: {
          addTooltip: "Create application - inline"
        },
        pagination: {
          labelDisplayedRows: "{from}-{to} of {count}",
          labelRowsSelect: "rows",
          firstTooltip: "First Page",
          previousTooltip: "First Page",
          nextTooltip: "Next Page",
          lastTooltip: "Last Page"
        },
        toolbar: {
          searchPlaceholder: "Search",
          nRowsSelected: "{0} application(s) selected"
        }
      },
      rowMenu: {
        edit: "Edit",
        deploy: "Deploy",
        import: "Import",
        addUser: "Add admin",
        addSubscription: "Add subscription",
        delete: "Delete",
        archive: "Archive",
        erase: "Erase"
      }
    },
    addUser: {
      createButton: "Create new admin",
      stepper: {
        titles: ["Required data*"]
      },
      fields: {
        email: {
          label: "E-mail address",
          description: "enter valid e-mail address",
          error: "Please provide a valid e-mail address."
        },
        forename: {
          label: "Forename",
          description: "max 255 chars",
          error: "Please provide a forename."
        },
        surname: {
          label: "Surname",
          description: "max 255 chars",
          error: "Please provide a surname."
        }
      }
    },
    addSubscription: {
      addButton: "Add subscription",
      stepper: {
        titles: ["Required data*"]
      },
      fields: {
        startDate: {
          label: "Start date",
          error:
            "Invalid date. The start date cannot be later than the end date."
        },
        endDate: {
          label: "End date",
          error:
            "Invalid date. The end date cannot be earlier than the start date."
        },
        product: {
          label: "Product",
          error: "Invalid product type."
        },
        credits: {
          label: "Credits",
          error: "Please provide credits count."
        },
        creditPrice: {
          label: "Credit Price",
          error: "Please provide credit price."
        }
      }
    },
    create: {
      createButton: "Create new gamification",
      stepper: {
        titles: [
          "Required data*",
          "Domains (optional)",
          "Additional settings (optional)",
          "Packages (optional)"
        ]
      },
      fields: {
        name: {
          label: "Application name",
          description: "max 255 chars",
          error: "Please provide a application name."
        },
        environment: {
          label: "Application environment",
          types: ["canary", "test", "rc", "live"]
        },
        accountManagerNote: {
          label: "Account manager",
          description: "max 255 chars",
          error: "Please provide a account manager."
        },
        note: {
          label: "Company",
          description: "max 255 chars",
          error: "Please provide a company."
        },
        mainDomainName: {
          label: "Main domain name",
          description: "default",
          error: "Please provide a valid domain name."
        },
        redirectDomainNames: {
          label: "Redirect domain names",
          addNewFieldButton: "add new field",
          removeFieldButton: "remove"
        },
        rewardCafeteriaEnabled: {
          label: "Access to an external prize catalog",
          description: "turn on/off"
        },
        workflowsEnabled: {
          label: "Workflows",
          description: "turn on/off"
        },
        battlesEnabled: {
          label: "Battles",
          description: "turn on/off"
        },
        oldAdminEnabled: {
          label: "Access to old admin",
          description: "turn on/off"
        },
        isEnterprise: {
          label: "Enterprise application",
          description: "notouch/enterprise"
        },
        billingEmail: {
          label: "Billing e-mail address",
          description:
            "E-mail address for creating a Stripe account and subscription",
          error: "Please provide a valid e-mail address."
        },
        billingForename: {
          label: "Billing forename",
          description:
            "Forename for creating a Stripe account and subscription",
          error: "Please provide a forename."
        },
        billingSurname: {
          label: "Billing surname",
          description: "Surname for creating a Stripe account and subscription",
          error: "Please provide a surname."
        },
        currency: {
          label: "Billing currency",
          description:
            'Currency for setting the default product "Price" in the chosen currency in Stripe.',
          error: "Please provide a valid currency."
        },
        hubSpotId: {
          label: "HubSpot ID",
          description: "optional",
          error: "Please provide a valid hubSpot ID."
        },
        packages: {
          label: "Packages",
          description: "uuid - xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
          addNewFieldButton: "add new field",
          removeFieldButton: "remove"
        }
      }
    },
    edit: {
      editButton: "Edit application",
      stepper: {
        titles: [
          "Required data*",
          "Domains (optional)",
          "Additional settings (optional)",
          "Packages (optional)"
        ]
      },
      fields: {
        name: {
          label: "Application name",
          description: "max 255 chars",
          error: "Please provide a application name."
        },
        environment: {
          label: "Application environment",
          types: ["canary", "test", "rc", "live"]
        },
        accountManagerNote: {
          label: "Account manager",
          description: "max 255 chars",
          error: "Please provide a account manager."
        },
        note: {
          label: "Company",
          description: "max 255 chars",
          error: "Please provide a company."
        },
        mainDomainName: {
          label: "Main domain name",
          error: "Please provide a valid domain name."
        },
        redirectDomainNames: {
          label: "Redirect domain names",
          addNewFieldButton: "add new field",
          removeFieldButton: "remove"
        },
        rewardCafeteriaEnabled: {
          label: "Access to an external prize catalog",
          description: "turn on/off"
        },
        workflowsEnabled: {
          label: "Workflows",
          description: "turn on/off"
        },
        battlesEnabled: {
          label: "Battles",
          description: "turn on/off"
        },
        oldAdminEnabled: {
          label: "Access to old admin",
          description: "turn on/off"
        },
        isEnterprise: {
          label: "Enterprise application",
          description: "notouch/enterprise"
        },
        billingEmail: {
          label: "Billing e-mail address",
          description:
            "E-mail address for creating a Stripe account and subscription",
          error: "Please provide a valid e-mail address."
        },
        billingForename: {
          label: "Billing forename",
          description:
            "Forename for creating a Stripe account and subscription",
          error: "Please provide a forename."
        },
        billingSurname: {
          label: "Billing surname",
          description: "Surname for creating a Stripe account and subscription",
          error: "Please provide a surname."
        },
        currency: {
          label: "Billing currency",
          description:
            'Currency for setting the default product "Price" in the chosen currency in Stripe.',
          error: "Please provide a valid currency.",
          warning:
            "This application is linked to Stripe, so you can no longer change the currency."
        },
        hubSpotId: {
          label: "HubSpot ID",
          description: "optional",
          error: "Please provide a valid hubSpot ID."
        },
        packages: {
          label: "Packages",
          description: "uuid - xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
          addNewFieldButton: "add new field",
          removeFieldButton: "remove"
        }
      }
    },
    deploy: {
      title: 'Would you like to deploy "{{application.name}}"?',
      cancelButton: "cancel",
      deployButton: "deploy now"
    },
    erase: {
      title: 'Erase application data: "{{application.name}}"',
      note:
        "This action will completely erase/delete application data. Previous database backups will not be affected.",
      field: {
        confirmAppName: "Enter app name to confirm deletion",
        removeFromList: "Remove/delete application from list",
        removeFromListDescription:
          "with its generated configuration and secrets",
        removeJobsAndDeployments: "Delete jobs and deployments logs"
      },
      error: {
        confirmAppName: "Incorrect application name"
      },
      eraseButton: "! Erase application !"
    },
    import: {
      importButton: "Import application data",
      fields: {
        sourceSiteName: {
          label: "Enter source site name*",
          error: "Please provide a site name."
        },
        sourceApplicationName: {
          label: "Enter source application name*",
          error: "Please provide a application name."
        }
      }
    },
    preview: {
      title: [
        'Last deployment logs - "{{application.name}}"',
        'Last import logs - "{{application.name}}"',
        'Job list - "{{application.name}}"'
      ],
      closeButton: "close",
      emptyLogs: "Empty logs",
      status: {
        "not-deployed-yet": "not deployed yet",
        pending: "pending",
        "in-progress": "in progress",
        failed: "failed",
        successful: "success"
      }
    }
  },
  prize: {
    prize: {
      edit: {
        createButton: "Update prize",
        stepper: {
          titles: ["Basic data (optional)", "Additional data (optional)"]
        },
        fields: {
          useCustom: {
            label: "Use custom name / description?",
            description: "boolean"
          },
          name: {
            label: "Prize name"
          },
          description: {
            label: "Prize description"
          },
          priceMargin: {
            label: "Price margin",
            description: "0-100%",
            error: "Please provide a valid value from range 1-100."
          },
          supplierMargin: {
            label: "Use supplier's default price margin"
          },
          disabled: {
            label: "Is disabled?",
            description: "boolean"
          }
        }
      },
      list: {
        title: "Prize list",
        column: {
          id: "ID",
          supplierItemId: "Item ID",
          image: "image",
          name: "name",
          supplier: "supplier",
          nettoPrice: "netto price (zł)",
          vatRate: "vat rate (%)",
          priceMargin: "price margin (%)",
          status: "status",
          actions: ""
        },
        status: {
          unavailable: "Unavailable",
          available: "Available"
        },
        actions: {
          delete: {
            tooltip: "Delete selected prizes",
            confirmation: "Delete selected prizes?"
          }
        },
        localization: {
          pagination: {
            labelDisplayedRows: "{from}-{to} of {count}",
            labelRowsSelect: "rows",
            firstTooltip: "First Page",
            previousTooltip: "First Page",
            nextTooltip: "Next Page",
            lastTooltip: "Last Page"
          },
          toolbar: {
            searchPlaceholder: "Search",
            nRowsSelected: "{0} prize(s) selected"
          }
        },
        rowMenu: {
          edit: "Edit",
          delete: "Delete"
        }
      }
    },
    category: {
      create: {
        createButton: "Create",
        fields: {
          name: {
            label: "name"
          },
          supplierCategories: {
            label: "supplier categories"
          }
        }
      },

      edit: {
        saveButton: "Save",
        fields: {
          name: {
            label: "name"
          },
          supplierCategories: {
            label: "supplier categories"
          }
        }
      },
      list: {
        title: "Category list",
        column: {
          id: "ID",
          name: "name",
          subcategory: "subcategory",
          supplier_categories: "supplier categories",
          actions: ""
        },
        actions: {
          delete: {
            tooltip: "Delete selected categories",
            confirmation: "Delete selected categories?"
          }
        },
        localization: {
          pagination: {
            labelDisplayedRows: "{from}-{to} of {count}",
            labelRowsSelect: "rows",
            firstTooltip: "First Page",
            previousTooltip: "First Page",
            nextTooltip: "Next Page",
            lastTooltip: "Last Page"
          },
          toolbar: {
            searchPlaceholder: "Search",
            nRowsSelected: "{0} categories selected"
          }
        },
        rowMenu: {
          add: "Add",
          edit: "Edit",
          delete: "Delete"
        }
      }
    },
    supplier: {
      edit: {
        createButton: "Update supplier",
        stepper: {
          titles: ["Additional data (optional)", "Webhook (optional)"]
        },
        fields: {
          priceMargin: {
            label: "Price margin",
            description: "0-100%",
            error: "Please provide a valid value from range 1-100."
          },
          webhook: {
            label: "URL",
            error: "Please provide a webhook URL."
          }
        }
      },
      list: {
        title: "Prize supplier list",
        column: {
          id: "ID",
          lastUpdate: "last update at",
          name: "name",
          priceMargin: "price margin (%)",
          actions: ""
        },
        actions: {
          delete: {
            tooltip: "Delete selected prize suppliers",
            confirmation: "Delete selected prize suppliers?"
          },
          createViaDrawer: {
            tooltip: "Create prize supplier - drawer"
          }
        },
        localization: {
          body: {
            addTooltip: "Create prize supplier - inline"
          },
          pagination: {
            labelDisplayedRows: "{from}-{to} of {count}",
            labelRowsSelect: "rows",
            firstTooltip: "First Page",
            previousTooltip: "First Page",
            nextTooltip: "Next Page",
            lastTooltip: "Last Page"
          },
          toolbar: {
            searchPlaceholder: "Search",
            nRowsSelected: "{0} prize supplier(s) selected"
          }
        },
        rowMenu: {
          edit: "Edit",
          delete: "Delete"
        }
      }
    },
    order: {
      list: {
        title: "Prize order list",
        column: {
          id: "ID",
          orderDate: "order date",
          application: "application",
          itemName: "item",
          budgetValue: "budget value",
          deliveryAddress: "address",
          deliveryEmail: "e-mail",
          deliveryPhone: "phone"
        }
      }
    }
  },
  job: {
    state: {
      pending: "pending",
      "in-progress": "in progress",
      failed: "failed",
      successful: "success",
      unknown: "unknown"
    },
    trigger: {
      manual: "manual",
      auto: "auto (parent)",
      technical: "technical",
      external: "external"
    },
    list: {
      title: "Job list",
      column: {
        id: "ID",
        name: "Name",
        trigger: "Trigger",
        createdAt: "Created at",
        startedAt: "Started at",
        finishedAt: "Finished at",
        state: "State",
        handler: "Handler",
        parentJob: "Parent job",
        application: "Related application"
      },
      filter: {
        createdAt: {
          label: "Created At"
        },
        type: {
          label: "Type",
          option: {
            all: "All",
            main: "Main",
            children: "Children"
          }
        },
        state: {
          label: "State",
          all: "All"
        },
        trigger: {
          label: "Trigger",
          all: "All"
        }
      }
    },
    details: {
      logs: {
        title: "Job Logs"
      },
      children: {
        title: "Job children"
      }
    }
  }
};
